"use client"
import { useEffect } from "react"

const TermsPage = ({ onBack }) => {
  // Scroll to top when the component mounts
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []); // Empty dependency array ensures this runs only once on mount
  return (
    <div className="pt-40 pb-16 bg-stone-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <button onClick={onBack} className="mb-8 text-emerald-800 hover:text-emerald-700 font-medium">
          ← Back to Home
        </button>

        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-charcoal-800 mb-2">Mediwhistle – Terms & Conditions</h1>
          <p className="text-stone-600 mb-8">Effective Date: September 2025</p>

          <div className="prose prose-stone max-w-none">
            <p className="mb-6">
              These Terms & Conditions ("Terms") govern your use of the Mediwhistle website and associated ordering
              platform (together, the "Platform"). By accessing or using the Platform, you agree to be bound by these
              Terms.
            </p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">1. Operator Information</h2>
            <p className="mb-6">
              The Platform is owned and operated by Mediwhistle Pty Ltd, registered in Victoria, Australia.
            </p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">2. General Information Only</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Content on the Platform is provided for general informational purposes only.</li>
              <li>Nothing on the Platform constitutes medical advice.</li>
              <li>
                Patients should always seek advice from a qualified healthcare professional before starting, stopping,
                or modifying any treatment.
              </li>
            </ul>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">3. Prescription-Only Access</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>
                Mediwhistle products are prescription-only and may only be accessed under the supervision of a
                registered healthcare professional.
              </li>
              <li>The Platform does not provide prescriptions or medical consultations.</li>
              <li>Product supply is strictly limited to eligible patients via approved prescribers and pharmacies.</li>
            </ul>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">4. Healthcare Professional Content</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Some sections of the Platform are intended only for Australian healthcare professionals.</li>
              <li>Access to these sections may require you to confirm that you are a healthcare professional.</li>
              <li>By accessing such content, you represent that you are authorised to do so.</li>
            </ul>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">5. Use of the Ordering Platform</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>
                The Mediwhistle ordering platform is for use by registered healthcare professionals, pharmacies, and
                authorised clinic staff only.
              </li>
              <li>You agree to provide accurate and complete information when using the ordering platform.</li>
              <li>
                Mediwhistle reserves the right to suspend or restrict access if misuse or unauthorised use is detected.
              </li>
            </ul>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">6. Intellectual Property</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>
                All content, logos, branding, and designs on the Platform are the property of Mediwhistle or its
                licensors.
              </li>
              <li>
                You may not copy, reproduce, modify, or distribute any part of the Platform without prior written
                consent.
              </li>
            </ul>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">7. Limitation of Liability</h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>
                Mediwhistle makes no warranties that the Platform will always be available, error-free, or secure.
              </li>
              <li>
                To the maximum extent permitted by law, Mediwhistle is not liable for any direct, indirect, or
                consequential loss or damage arising from your use of the Platform or reliance on its content.
              </li>
              <li>Nothing in these Terms excludes liability that cannot be excluded under Australian law.</li>
            </ul>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">8. Privacy</h2>
            <p className="mb-6">
              By using the Platform, you agree that any personal information you provide will be handled in accordance
              with our Privacy Policy.
            </p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">9. Governing Law</h2>
            <p className="mb-6">
              These Terms are governed by the laws of Victoria, Australia. Any disputes will be subject to the exclusive
              jurisdiction of the courts of Victoria.
            </p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">10. Changes to Terms</h2>
            <p className="mb-6">
              Mediwhistle may update these Terms from time to time. Updates will be effective once published on this
              page.
            </p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">11. Contact</h2>
            <p className="mb-6">
              For any questions regarding these Terms, please contact:
              <br />
              Email:{" "}
              <a href="mailto:admin@mediwhistle.com.au" className="text-emerald-800 hover:text-emerald-700 underline">
                admin@mediwhistle.com.au
              </a>
            </p>

            <div className="border-t pt-6 mt-8">
              <p className="font-medium text-charcoal-800">
                By using the Mediwhistle Platform, you acknowledge that you have read, understood, and agree to be bound
                by these Terms & Conditions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsPage
